import { CheckCircle2, CircleAlert, X } from "lucide-react";

export interface ToastMessage {
  kind: "success" | "error";
  text: string;
}

export function Toast({ message, onClose }: { message: ToastMessage | null; onClose: () => void }) {
  if (!message) return null;
  return (
    <div className={`toast toast-${message.kind}`} role="status">
      {message.kind === "success" ? <CheckCircle2 size={19} /> : <CircleAlert size={19} />}
      <span>{message.text}</span>
      <button className="icon-button" onClick={onClose} aria-label="Close message"><X size={17} /></button>
    </div>
  );
}
